import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import classes from './Exercise.module.css';

const exercise = (props) => {
    // console.log('SELECTED: ',props.selected);
    let header_icon = '';
    if (props.selected === 'NewExerciseList') {
        header_icon = (<div className={classes.AddCircle}><AddCircleOutlineIcon style={{color: 'green'}} fontSize={"large"}/></div>);
    }


    // <div className="card-body">
    //     <div className={"cardText "+classes.truncate}>{props.description}</div>
    // </div>

    const chosenStyle = {height: 90,boxShadow: props.selectedInUrl ? '0px 0px 4px 2px #52abcc' : 'none'};
    return (
        <div className={"card " + classes.Exercise + ' ' + (props.selected==='selected' ? classes.selected : '')} style={chosenStyle} onClick={props.clicked}>
            <h4 className="card-header">{props.name} {header_icon}</h4>
        </div>
    );
};

export default exercise;